<template>
    <el-container class="archive-my-process">
        <ArchiveFilesTabs
                v-if="isShowArchiveFilesTabs"
                ref="archiveTable"
                :templateId="instancesInfo.archiveTemplateId"
                :processInstanceId="instancesInfo.id"
                :instancesInfo="instancesInfo"
                :bizType="bizType"
                :taskId="taskId"
                :taskInfo="taskInfo"
                :taskAssigneeId="taskAssigneeId"
                :isSubProcess="isSubProcess"
                :isCloseFileUpload="isCloseFileUpload"
                @handleFullScreen="handleFullScreen"
                :isFullScreen="isFullScreen"
                :tbHeight="'500'"
            />
        <el-dialog
            title="文件管理"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowFullArchiveFilesTabs"
            @close="hideDialog"
            >
            <ArchiveFilesTabs
                v-if="isShowFullArchiveFilesTabs"
                ref="archiveTable"
               :templateId="instancesInfo.archiveTemplateId"
                :processInstanceId="instancesInfo.id"
                :instancesInfo="instancesInfo"
                :bizType="bizType"
                :taskId="taskId"
                :taskAssigneeId="taskAssigneeId"
                :isSubProcess="isSubProcess"
                :isCloseFileUpload="isCloseFileUpload"
                @handleFullScreen="handleFullScreen"
                :isFullScreen="isFullScreen"
                :tbHeight="'462'"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowFullArchiveFilesTabs=false">取 消</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
    import ArchiveFilesTabs from './ArchiveFilesTabs';
    import { getProcessInstancesDetail } from '@/data-model';

    export default {
        components: {
            ArchiveFilesTabs
        },
        data () {
            return {
                isShowArchiveFilesTabs: false,
                isShowFullArchiveFilesTabs: false,
                instancesInfo: {},
                isFullScreen: false,
                rootPath: '/document/archive'
            };
        },
        props: {
            taskAssigneeId: {
                type: String,
                default: ''
            },
            bizType: { // 文件上传的类型。 task、process
                type: String
                // default: 'process'
            },
            taskId: {
                type: String
            },
            templateId: { // 档案模板id
                type: String
            },
            processInstanceId: { // 流程实例id
                type: String
            },
            isSubProcess: {
                type: Boolean,
                default: false
            },
            taskInfo: {
                type: Object
            },
            isCloseFileUpload: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // console.log(this.isSubProcess);
            this.initPage();
        },
        methods: {
            async initPage () {
                this.isShowArchiveFilesTabs = false;
                this.instancesInfo = await getProcessInstancesDetail(this.processInstanceId);
                this.isShowArchiveFilesTabs = true;
                // setTimeout(() => { // 默认回显值
                //     this.$refs.archiveTable._initPage();
                // }, 0);
            },
            handleFullScreen () {
                // setTimeout(() => { // 默认回显值
                //     this.$refs.archiveTable._initPage();
                // }, 0);
                this.isFullScreen = true;
                this.isShowFullArchiveFilesTabs = true;
            },
            hideDialog () {
                this.isFullScreen = false;
            }
        }
    };
</script>

<style lang="less">
    .archive-my-process {
        flex: 1;
        .el-aside {
            display: flex;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/components/ArchiveFilesTabs/ArchiveFilesList.vue